import { QuestionType } from './types'

export const QuestionTarget = {
  PERSON_PHONE_NUMBER: 'person.phoneNumber',
  PERSON_HOME_PHONE_NUMBER: 'person.homePhoneNumber',
  PERSON_WORK_PHONE_NUMBER: 'person.workPhoneNumber',
  PERSON_EMAIL: 'person.email',
} as const

export type QuestionTargetValue = (typeof QuestionTarget)[keyof typeof QuestionTarget]

export const PHONE_QUESTION_TARGETS = [
  QuestionTarget.PERSON_PHONE_NUMBER,
  QuestionTarget.PERSON_HOME_PHONE_NUMBER,
  QuestionTarget.PERSON_WORK_PHONE_NUMBER,
]

export const EMAIL_QUESTION_TARGETS = [QuestionTarget.PERSON_EMAIL]

export const DEFAULT_QUESTION_TARGET_BY_TYPE: Partial<Record<QuestionType, QuestionTargetValue>> = {
  [QuestionType.PHONE_NUMBER]: QuestionTarget.PERSON_PHONE_NUMBER,
  [QuestionType.EMAIL]: QuestionTarget.PERSON_EMAIL,
}

export const QUESTION_TARGET_LABELS: Record<string, string> = {
  [QuestionTarget.PERSON_PHONE_NUMBER]: 'Mobile phone (profile)',
  [QuestionTarget.PERSON_HOME_PHONE_NUMBER]: 'Home phone (profile)',
  [QuestionTarget.PERSON_WORK_PHONE_NUMBER]: 'Work phone (profile)',
  [QuestionTarget.PERSON_EMAIL]: 'Email (profile)',
  '': "Don't update profile",
}

export const getTargetOptionsForQuestionType = (questionType?: QuestionType) => {
  if (questionType === QuestionType.PHONE_NUMBER) {
    return [
      { label: QUESTION_TARGET_LABELS[QuestionTarget.PERSON_PHONE_NUMBER], value: QuestionTarget.PERSON_PHONE_NUMBER },
      { label: QUESTION_TARGET_LABELS[QuestionTarget.PERSON_HOME_PHONE_NUMBER], value: QuestionTarget.PERSON_HOME_PHONE_NUMBER },
      { label: QUESTION_TARGET_LABELS[QuestionTarget.PERSON_WORK_PHONE_NUMBER], value: QuestionTarget.PERSON_WORK_PHONE_NUMBER },
      { label: QUESTION_TARGET_LABELS[''], value: '' },
    ]
  }
  if (questionType === QuestionType.EMAIL) {
    return [
      { label: QUESTION_TARGET_LABELS[QuestionTarget.PERSON_EMAIL], value: QuestionTarget.PERSON_EMAIL },
      { label: QUESTION_TARGET_LABELS[''], value: '' },
    ]
  }
  return []
}

export const showsQuestionTargetField = (questionType?: QuestionType) =>
  questionType === QuestionType.PHONE_NUMBER || questionType === QuestionType.EMAIL

export const normalizeQuestionTarget = (target?: string | null) => target || null

export const serializeQuestionTarget = (target?: string | null) => target || null
